import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route
    key="/business/color-trends/applied/:id"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Color Trends Applied',
            item: '/business/color-trends/applied',
          },
        ]}
      />
    }
  >
    <Route path="business/color-trends/applied/:id" element={<AsyncPage />} />
  </Route>
);
